import { normalizeStringInObject } from "../utils/normalize";
import axiosIntanceApiFacebook from "./../helper/axiosIntanceApiFacebook";

function getFormData(object) {
    const formData = new FormData();
    if (object) {
        Object.keys(object).forEach(key => formData.append(key, object[key]));
        return formData;
    }
    return [];
}
const accessToken = (params) => {
    return axiosIntanceApiFacebook.post('/getAccessToken', getFormData(normalizeStringInObject(params)));
}
const getListRecentChat = (params) => {
    return axiosIntanceApiFacebook.post('/getListConversationInArray', normalizeStringInObject(params));
};
const getConversation = (params) => {
    return axiosIntanceApiFacebook.post(`/getNextPersonalConversation`, getFormData(normalizeStringInObject(params)));
};
const getConversationNew = (params) => {
    return axiosIntanceApiFacebook.post(`/getConversation`, getFormData(normalizeStringInObject(params)));
};
const sendMessage = (params) => {
    return axiosIntanceApiFacebook.post(`/sendMessage`, getFormData(normalizeStringInObject(params)));
};
const getInfo = (params) => {
    return axiosIntanceApiFacebook.post(`/getOa`, getFormData(normalizeStringInObject(params)));
};
const listPage = (params) => {
    return axiosIntanceApiFacebook.post(`/listPage`, getFormData(normalizeStringInObject(params)));
};
const deletePage = (params) => {
    return axiosIntanceApiFacebook.post(`/deletePage`, getFormData(normalizeStringInObject(params)));
}
const updateApplicationFacebook = (params) => {
    return axiosIntanceApiFacebook.post(`/applicationFacebook`, getFormData(normalizeStringInObject(params)));
}
const checkApplicationFacebook = (params) => {
    return axiosIntanceApiFacebook.post(`/checkApplicationFacebook`, getFormData(normalizeStringInObject(params)));
}
const posts = (params) => {
    return axiosIntanceApiFacebook.post(`/posts`, normalizeStringInObject(params));
}
const create_post = (params) => {
    return axiosIntanceApiFacebook.post(`/createNewFeed`, normalizeStringInObject(params));
}
const delete_post = (params) => {
    return axiosIntanceApiFacebook.post(`/deleteNewFeed`, normalizeStringInObject(params));
}
const comments = (params) => {
    return axiosIntanceApiFacebook.post(`/comments`, normalizeStringInObject(params));
}
const viewReplies = (params)=>{
    return axiosIntanceApiFacebook.post('/commentReplies',normalizeStringInObject(params))
}
const createComment = (params)=>{
    return axiosIntanceApiFacebook.post('/createComment',normalizeStringInObject(params))
}
const createReplyComment = (params)=>{
    return axiosIntanceApiFacebook.post('/createReplyComment',normalizeStringInObject(params))
}
const deleteComment = (params)=>{
    return axiosIntanceApiFacebook.post('/deleteComment',normalizeStringInObject(params))
}
const like = (params)=>{
    return axiosIntanceApiFacebook.post('/like',normalizeStringInObject(params))
}
const revoke_like = (params)=>{
    return axiosIntanceApiFacebook.post('/revokeLike',normalizeStringInObject(params))
}
const updateComment = (params)=>{
    return axiosIntanceApiFacebook.post('/updateComment',normalizeStringInObject(params))
}
const save_config_plugin = (params)=>{
    return axiosIntanceApiFacebook.post('/save_config_plugin',normalizeStringInObject(params))
}
const updateUserResponseMessageItem = (params) => {
    return axiosIntanceApiFacebook.post(`/updateUserResponseMessageItem`, normalizeStringInObject(params));
};
export default {
    getConversation,
    getConversationNew,
    getListRecentChat,
    accessToken,
    sendMessage,
    getInfo,
    listPage,
    deletePage,
    updateApplicationFacebook,
    checkApplicationFacebook,
    posts,
    comments,
    viewReplies,
    createComment,
    createReplyComment,
    deleteComment,
    like,
    revoke_like,
    updateComment,
    deleteComment,
    delete_post,
    create_post,
    save_config_plugin,
    updateUserResponseMessageItem
}

